import { toBnDigits } from "./format-bn";

/**
 * Format a number as BDT using Bangladeshi/Indian digit grouping (1,25,000).
 * Pass `lang: "bn"` to render digits in Bangla numerals (১,২৫,০০০) — the ৳
 * symbol stays the same in both scripts.
 */
export function formatBDT(
  value: number | string | null | undefined,
  lang: "en" | "bn" = "en",
): string {
  const n = typeof value === "string" ? Number(value) : (value ?? 0);
  if (!Number.isFinite(n)) return lang === "bn" ? "৳০" : "৳0";
  const negative = n < 0;
  const abs = Math.abs(n);
  const [intPart, decPart] = abs.toFixed(0).split(".");
  // Indian grouping: last 3 digits, then groups of 2
  let out = "";
  const s = intPart;
  if (s.length <= 3) out = s;
  else {
    const last3 = s.slice(-3);
    const rest = s.slice(0, -3);
    const withCommas = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
    out = `${withCommas},${last3}`;
  }
  const body = `${out}${decPart ? `.${decPart}` : ""}`;
  const localized = lang === "bn" ? toBnDigits(body) : body;
  return `৳${negative ? "-" : ""}${localized}`;
}

export function productImageUrl(name: string): string {
  // Simple mapping: seeded images live in src/assets/products bundled by Vite.
  return name;
}
